import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
const SectionNoContent = () => {
  return (
    <section id="no-content" className='pt-5 pb-5'>
      <Container className='pt-5 pb-5'>
        <Row>
          <Col className='text-center fs-4 fst-italic'>Content coming soon. Please check back later.</Col>
        </Row>
      </Container>
    </section>
  )
}

export default SectionNoContent